export const notificationsKeys = {
    notifications: (subdomain, userId) => ['notifications', subdomain, userId],
};
